<template>
  <div class="wrapper">
    <div class="animated fadeIn">
      <b-container v-if="data != null">
        <div class="booking-add">
          <b-card v-for="(booking, key) in data" :key="'booking-' + key" no-body>
            <div slot="header">
              <b-row>
                <b-col>
                  Booking #<b>{{booking.id}}</b><br>
                  Trip Description: <b>{{booking.trip_description}}</b><br>
                  Pick Up: <b>{{booking.first_pick_up | moment("DD/MM/YYYY HH:mm")}}</b>
                </b-col>
                <b-col class="text-right">
                  <b-button variant="link" :to="'/bookings/'+booking.id+ '/edit'" target="_blank">Edit</b-button>
                </b-col>
              </b-row>
            </div>
            <b-row>
              <b-col>
                <b-table hover :items="booking.clients" :fields="fields" class="m-0"></b-table>
              </b-col>
            </b-row>
          </b-card>
        </div>
      </b-container>
      <b-container v-if="data == null">
        <div class="booking-add">
          <b-card>
            <div slot="header">Agent Details</div>
            <b-row>
              <b-col md="6">
                <b-form-group
                  id="fieldset-agentSelect"
                  label="Select Agent"
                  label-for="agentSelect"
                >
                  <treeselect v-model="form.agent_id" :multiple="false" :options="select2Agents"
                              placeholder="Select Agent"/>
                </b-form-group>
              </b-col>
              <b-col md="6">
                <v-input-travel-agent
                  v-model="form.travel_agent_id"
                  :options="select2TravelAgents"
                  name="travelAgents">
                </v-input-travel-agent>
              </b-col>
            </b-row>
          </b-card>
          <b-card>
            <div slot="header">Import from CSV</div>
            <b-row>
              <b-col>
                <b-form-group id="fieldset-laodcsv" label="Import from CSV" label-for="csv_file">
                  <b-form-file id="csv_file" name="csv_file" ref="files" class="form-control"
                               @change="handleFilesUpload($event)"/>
                </b-form-group>
              </b-col>
            </b-row>
          </b-card>

          <b-row class="my-4">
            <b-col>
            </b-col>
            <b-col class="text-right">
              <b-button type="submit" variant="success" @click="submit">
                <i class="fa fa-dot-circle-o"></i> Submit
              </b-button>
              <b-button type="reset" variant="danger" to="/bookings">
                <i class="fa fa-ban"></i> Cancel
              </b-button>
            </b-col>
          </b-row>
        </div>
      </b-container>
    </div>
  </div>
</template>

<script>
import { common, validations } from './mixins'
import 'es6-promise/auto'
import flatPickr from 'vue-flatpickr-component'
import 'flatpickr/dist/flatpickr.css'
// import the component
import Treeselect from '@riophae/vue-treeselect'
// import the styles
import '@riophae/vue-treeselect/dist/vue-treeselect.css'
import moment from 'moment'

export default {
  name: 'BookingEdit',
  props: ['id'],
  components: {
    flatPickr,
    Treeselect
  },
  data () {
    return {
      fields: ['full_name', 'persons', 'pick_up_location', 'drop_off_location', 'notes'],
      data: null,
      file: '',
      form: {
        agent_id: null,
        travel_agent_id: null,
        file: null
      },
      select2Agent: null
    }
  },
  validations: {
    ...validations
  },
  methods: {
    submit () {
      let payload = { ...this.form }
      payload.file = this.file
      let xhr = this.$store.dispatch('bookings/import', payload)

      xhr.then(
        (res) => {
          this.data = res.data.data
        }
      )
    },
    handleFilesUpload (e) {
      this.file = e.target.files[0]
    }
  },
  mixins: [common],
  created () {
    this.$store.dispatch('agents/index')
    this.$store.dispatch('travelAgents/index')
  }
}
</script>



// WEBPACK FOOTER //
// src/views/bookings/Import.vue